var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248.32 230.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2-2",
    "data-name": "Warstwa 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.58,
    height: 35.58,
    style: {
      fill: "#f19106"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.72,
    y: 60.3,
    width: 57.9,
    height: 57.9,
    style: {
      fill: "#84bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.06,121.33c-9-9.28-25.69-25.3-24.2-36,4.42-31.83-13.54-54.4-43.67-70.65-16-8.64-36.3-13.09-56-11.68V2.7H64.62V60.3h56.72v57.9H64.62v57.6h57.21v54.44H179s5.61-15.22,10.26-21c5.83-7.24,26-3.61,36.34-5.57,21.26-4,6.24-22.16,6.57-25.41.46-4.49,10.2-5.07,6.56-11.57-1.27-2.28-2.48-2.17-5.39-4.8,14.8-9-1.28-11.16,1.9-21.95,1.28-4.36,19.26-10,10.85-18.61",
    style: {
      fill: "#84bd4b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 118.2 64.62 118.2 64.62 175.8 121.83 175.8 121.34 118.2",
    style: {
      fill: "#474f5a",
      fillRule: "evenodd"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.658d856615bdc16ec4215cf5d544913d.svg";
export { ForwardRef as ReactComponent };